import * as React from "react";
import { useMemo } from "react";

import { useAdvancedFeatures } from "@/hooks/use-advanced-features";

import { installThemes, Theme, ThemeFactoryOptions } from "../editor/themes";

interface CanvasThemesProviderProps {
  children: React.ReactNode;
}
interface ICanvasThemesProviderContext {
  themes: Theme[];
}

export const CanvasThemesProviderContext = React.createContext<ICanvasThemesProviderContext>(
  undefined
);

export default function CanvasThemesProvider(props: CanvasThemesProviderProps) {
  const { advancedFeaturesEnabled } = useAdvancedFeatures();

  const options: ThemeFactoryOptions = useMemo(
    () => ({
      advancedFeaturesEnabled,
    }),
    [advancedFeaturesEnabled]
  );

  const themes = React.useMemo(() => installThemes(options), [options]);

  return (
    <CanvasThemesProviderContext.Provider value={{ themes }}>
      {props.children}
    </CanvasThemesProviderContext.Provider>
  );
}
